import {Injectable, Injector} from '@angular/core';
import {ModalDirective} from 'ng2-bootstrap';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {PlatformLocation} from '@angular/common';
import {environment} from '../../../environments/environment';
import {isNil, merge} from 'lodash';
import {ServiceLocator} from './service-locator';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {ClientSettingsService} from '../settings/client-settings.service';

@Injectable()
export class BaseService {

  private editModal: ModalDirective;

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
  }

  setDialog(modalDir: ModalDirective) {
    this.editModal = modalDir;
  }

  getDialog() {
    return this.editModal;
  }

  handleError(error: HttpErrorResponse) {
    if (!environment.production) {
      console.error(error);
    }
    return throwError(error);
  }

  get settingsSvc(): ClientSettingsService {
    return this.injector.get(ClientSettingsService);
  }

  get sanitizerSvc(): DomSanitizer {
    return this.injector.get(DomSanitizer);
  }

   appHeaders(appModule: string): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('X-BMS-App-Id', '1'); /* ubaciti konstantu nekako */
    headers = headers.append('X-BMS-App-Module', appModule);
    if (!isNil(this.settingsSvc.getActiveCompany())) {
      headers = headers.append('X-BMS-Active-Company-Id', this.settingsSvc.getActiveCompany().id);
    }
    if (!isNil(this.settingsSvc.getActiveStockroom())) {
      headers = headers.append('X-BMS-Active-Stockroom-Id', this.settingsSvc.getActiveStockroom().id);
    }
    return headers;
  }

  protected post<T>(url: string, appModule: string, data: any): Observable<T> {
    return this.http2.post<T>(this.prepareUrl(url), data, {
      headers: this.appHeaders(appModule),
    });
  }

  protected postText(url: string, appModule: string, data: any): Observable<string> {
    return this.http2.post(this.prepareUrl(url), data, {
      headers: this.appHeaders(appModule),
      responseType: 'text'
    });
  }

  protected put<T>(url: string, appModule: string, data: any): Observable<T> {
    return this.http2.put<T>(this.prepareUrl(url), data, {
      headers: this.appHeaders(appModule),
    });
  }

  protected patch<T>(url: string, appModule: string, data: any): Observable<T> {
    return this.http2.patch<T>(this.prepareUrl(url), data, {
      headers: this.appHeaders(appModule),
    });
  }

  protected get<T>(url: string, appModule: string, opts?: object, params?: any): Observable<T> {
    let options = {
      headers: this.appHeaders(appModule),
    };
    if (!isNil(options)) {
      options = merge(opts, options);
    }
    return this.http2.get<T>(this.prepareUrl(url), options);
  }

  protected _delete<T>(url: string, appModule: string): Observable<T> {
    return this.http2.delete<T>(this.prepareUrl(url), {
      headers: this.appHeaders(appModule),
    });
  }

  protected downloadFile(url: string, appModule: string, qry: any, showPrice?: any,  printSerial?: boolean ): Observable<Blob> {
    return this.http2.post(this.prepareUrl(url), JSON.stringify({'qry': qry, 'showPrice': showPrice, 'printSerial': printSerial}), {
      headers: this.appHeaders(appModule),
      responseType: 'blob'
    });
  }

  protected uploadFile(url: string, appModule: string, data: any): Observable<any> {
    const headers = this.appHeaders(appModule);
    headers.append('enctype', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.http2.post(this.prepareUrl(url), data, { headers: headers });
  }

  private prepareUrl(url: string): string {
    const baseUrl = this.platformLocation.getBaseHrefFromDOM();
    if (baseUrl.length > 1) {
      return this.platformLocation.getBaseHrefFromDOM() + url;
    } else {
      return url;
    }
  }
}
